document.addEventListener("DOMContentLoaded", () => {
  // Czy label ze swatchem jest faktycznie niewidoczny (ukryty przez CSS)?
  const isHidden = (label) => {
    if (!label) return false;
    // offsetParent === null łapie display:none / visibility:hidden / ukrycie w DOM
    if (label.offsetParent === null) return true;
    const cs = getComputedStyle(label);
    return cs.display === "none" || cs.visibility === "hidden";
  };

  // Upewnij się, że zaznaczony kolor nie jest ukryty; jeśli tak — wybierz pierwszy widoczny
  const fixColorFieldset = (fieldset) => {
    const checked = fieldset.querySelector('input[type="radio"]:checked');
    if (checked && isHidden(checked.closest(".variant-option__button-label"))) {
      checked.checked = false;
    }

    if (!fieldset.querySelector('input[type="radio"]:checked')) {
      const firstVisible = Array.from(
        fieldset.querySelectorAll('.variant-option__button-label input[type="radio"]')
      ).find((inp) => !isHidden(inp.closest(".variant-option__button-label")));
      if (firstVisible) {
        firstVisible.checked = true;
        firstVisible.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  };

  const run = () => {
    document
      .querySelectorAll(".variant-picker__form fieldset.variant-option--swatches")
      .forEach(fixColorFieldset);
  };

  // Lekki „scheduler”, żeby dać Horizoonowi czas na przebudowę DOM/CSS
  let rafId = null;
  const schedule = () => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      // małe opóźnienie, by CSS :has() już ukrył elementy
      setTimeout(run, 60);
    });
  };

  // Start
  schedule();

  // Każda zmiana/klik w pickerze wariantów → popraw wybór
  document.body.addEventListener("change", (e) => {
    if (e.target.matches(".variant-picker__form input[type=radio]")) schedule();
  });
  document.body.addEventListener("click", (e) => {
    if (e.target.closest(".variant-picker__form")) schedule();
  });

  // Horizon często przebudowuje DOM — obserwuj i popraw po każdej podmianie
  const target = document.querySelector(".variant-picker__form") || document.body;
  const mo = new MutationObserver(schedule);
  mo.observe(target, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["aria-disabled", "data-option-available"],
  });

  // Edytor sekcji Shopify
  document.addEventListener("shopify:section:load", schedule);
});
